import { render, staticRenderFns } from "./CustomerToOrder.vue?vue&type=template&id=f6ec1f3a&"
import script from "./CustomerToOrder.vue?vue&type=script&lang=js&"
export * from "./CustomerToOrder.vue?vue&type=script&lang=js&"
import style0 from "./CustomerToOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports